@if (addressValidationResult) {
  @if (!addressValidationResult.found) {
    <div class="address-validation-error">
      <fa-icon [icon]="circleExclamation"></fa-icon>
      <div>
        <div>
          {{ 'addressValidation.addressError' | transloco }}
        </div>
      </div>
    </div>
  } @else {
    @if (
      addressValidationResult.discrepancies &&
      addressValidationResult.correctedAddressList
    ) {
      <div class="address-validation-warning">
        <fa-icon [icon]="circleExclamation"></fa-icon>
        <div>
          <div>
            {{ 'addressValidation.addressWarning' | transloco }}
            @for (
              key of getDictionaryKeys(
                addressValidationResult.correctedAddressList
              );
              track key
            ) {
              <span>
                {{ addressValidationResult.correctedAddressList[key] }}
              </span>
            }
            <span class="suggestion" (click)="replaceWithSuggestion()">{{
              'addressValidation.addressSuggestion' | transloco
            }}</span>
          </div>
          <div class="instructions">
            {{ 'addressValidation.instructions' | transloco }}
          </div>
        </div>
      </div>
    }
  }
  <ng-template #found>
    @if (
      addressValidationResult.discrepancies &&
      addressValidationResult.correctedAddressList
    ) {
      <div class="address-validation-warning">
        <fa-icon [icon]="circleExclamation"></fa-icon>
        <div>
          <div>
            {{ 'addressValidation.addressWarning' | transloco }}
            @for (
              key of getDictionaryKeys(
                addressValidationResult.correctedAddressList
              );
              track key
            ) {
              <span>
                {{ addressValidationResult.correctedAddressList[key] }}
              </span>
            }
            <span class="suggestion" (click)="replaceWithSuggestion()">{{
              'addressValidation.addressSuggestion' | transloco
            }}</span>
          </div>
          <div class="instructions">
            {{ 'addressValidation.instructions' | transloco }}
          </div>
        </div>
      </div>
    }
  </ng-template>
}
